export default __webpack_public_path__ + "static/media/element_spec_68.bea0e562.jpg";